import React from 'react';
import UploadReceipt from './components/upload/UploadReceipt';
import ReceiptHistory from './components/receipt/ReceiptHistory';
import EditReceiptPage from './components/receipt/EditReceiptPage';
import SharedReceiptPage from './components/receipt/SharedReceiptPage';
import ReceiptsOverviewWidget from './widgets/ReceiptsOverviewWidget';

const receiptsModule = {
  id: 'receipts',
  displayNameKey: 'module.receipts',
  icon: 'fa-receipt',
  order: 10,

  navEntries: [
    { path: '/upload',   labelKey: 'uploadReceipt',  icon: 'fa-upload',  order: 10 },
    { path: '/receipts', labelKey: 'receiptHistory', icon: 'fa-history', order: 20 },
  ],

  routes: [
    { path: '/upload',                    element: <UploadReceipt />,     private: true  },
    { path: '/receipts',                  element: <ReceiptHistory />,    private: true  },
    { path: '/receipts/:receiptId/edit',  element: <EditReceiptPage />,   private: true  },
    { path: '/shared/:shareToken',        element: <SharedReceiptPage />, private: false },
  ],

  // Spending reports live in the budget module: they combine receipts with
  // card statements so a purchase with both is counted once.
  reportSections: [],

  dashboardWidgets: [
    { key: 'receipts-overview', component: ReceiptsOverviewWidget, order: 10 },
  ],
};

export default receiptsModule;
